module.exports = __webpack_public_path__ + "coin-7cbbf4d4bfa4af49e05e.png";